require('slick-carousel');
require('./index.scss');
require('./component-slider');

module.exports = 'component-slider';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/slider/index.js
 ** module id = 113
 ** module chunks = 1
 **/